import { useEffect, useState } from "react";
import { useProfile } from "../../../context/ProfileContext";
import { clientService } from "../../../shared/services/api/client/clientService";

export function useClientOptions(searchTerm: string) {
	const { isSuperAdmin, permissionLevel, userClientId } = useProfile();
	const [clientOptions, setClientOptions] = useState<{ id: string; label: string }[]>([]);
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		// 🔒 Se não tiver permissão, nem tenta
		if (!isSuperAdmin && permissionLevel !== 2 && permissionLevel !== 10) return;

		const search = typeof searchTerm === "string" ? searchTerm.trim() : "";
		const cleanedName = search.replace("(Inativo)", "");
		const clientId = isSuperAdmin || permissionLevel === 2 ? "" : userClientId;

		const timeout = setTimeout(() => {
			// 🔍 Evita requisição vazia demais sem termo e sem clientId
			if (!cleanedName && !clientId) return;

			setLoading(true);

			clientService.getSelect(1, cleanedName, "", "", "", clientId).then((result) => {
				if (!(result instanceof Error)) {
					setClientOptions((result.data ?? []).map((client) => ({ id: client.id, label: client.name })));
				}
				setLoading(false);
			});
		}, 400);

		return () => clearTimeout(timeout);
	}, [searchTerm, isSuperAdmin, permissionLevel, userClientId]);

	return { clientOptions, loading };
}
